import { WalletType } from "../types/rail.types";
import ReactCountryFlag from "react-country-flag";
import {
  BitcoinIcon,
  EthereumIcon,
  TetherIcon,
  BinanceIcon,
  TronIcon,
  SolanaIcon
} from "../components/ui/Icons";
import { CryptoPrices } from "../types/application.types";
import { FiatExchangeRates } from '../types/financial.types';
import {CryptoWalletType, MainAccountType} from '../types/assets.types';
export const FIAT_WALLETS: MainAccountType[] = [
  {
    currency: "USD",
    name: "USA",
    type: "0",
    balance:"0",
    icon: () => <div className="wallet-card-icon"><div className="fiat-flag-icon"><ReactCountryFlag countryCode="US" svg /></div></div>
  },
  // {
  //   currency: "EUR",
  //   name: "EUR",
  //   type: "0",
  //   shortName: "EUR",
  //   icon: () => <div className="wallet-card-icon"><div className="fiat-flag-icon"><ReactCountryFlag countryCode="EU" svg /></div></div>
  // },
  // {
  //   currency: "GBP",
  //   name: "UK",
  //   type: "0",
  //   shortName: "GBP",
  //   icon: () => <div className="wallet-card-icon"><div className="fiat-flag-icon"><ReactCountryFlag countryCode="GB" svg /></div></div>
  // },
  // {
  //   currency: "MEX",
  //   name: "MEX",
  //   type: "0",
  //   shortName: "MEX",
  //   icon: () => <div className="wallet-card-icon"><div className="fiat-flag-icon"><ReactCountryFlag countryCode="MX" svg /></div></div>
  // },
  // {
  //   currency: "PAN",
  //   name: "PAN",
  //   type: "0",
  //   shortName: "PAN",
  //   icon: () => <div className="wallet-card-icon"><div className="fiat-flag-icon"><ReactCountryFlag countryCode="PA" svg /></div></div>
  // },
  // {
  //   currency: "UAE",
  //   name: "UAE",
  //   type: "0",
  //   shortName: "AED",
  //   icon: () => <div className="wallet-card-icon"><div className="fiat-flag-icon"><ReactCountryFlag countryCode="AE" svg /></div></div>
  // },
];

export const CUSTODIAN_WALLETS: WalletType[] = [
  {
    currency: "BTC",
    name: "Bitcoin",
    type: "1",
    shortName: "BTC",
    network: "bitcoin",
    icon: () => <div className="wallet-card-icon"><BitcoinIcon size={36} color="#B3A369" /></div>
  },
  {
    currency: "ETH",
    name: "Ethereum",
    type: "1",
    shortName: "ETH",
    network: "ethereum",
    icon: () => <div className="wallet-card-icon"><EthereumIcon size={36} color="#B3A369" /></div>
  },
  {
    currency: "USDT",
    name: "USDT ERC20",
    type: "1",
    shortName: "USDT",
    network: "ethereum",
    icon: () => <div className="wallet-card-icon"><TetherIcon size={36} color="#26A17B" /></div>
  },
  {
    currency: "TRX",
    name: "TRON",
    type: "1",
    shortName: "TRX",
    network: "tron",
    icon: () => <div className="wallet-card-icon"><TronIcon size={36} color="#FF060A" /></div>,
    balanceField: "trxBalance"
  },
  {
    currency: "USDT_TRON",
    name: "USDT TRON",
    type: "1",
    shortName: "USDT",
    network: "tron",
    icon: () => <div className="wallet-card-icon"><TetherIcon size={36} color="#26A17B" /></div>,
    balanceField: "usdtBalance",
    requiresParentWallet: "TRX"
  },
  {
    currency: "USDC",
    name: "USDC",
    type: "1",
    shortName: "USDC",
    network:"",
    icon: () => <div className="wallet-card-icon"><TetherIcon size={36} color="#2775CA" /></div>
  },
];

export const CRYPTO_WALLETS: CryptoWalletType[] = [
  { 
    token:"btc",    
    name:"Bitcoin",
    icon: () => <div className="wallet-card-icon"><BitcoinIcon size={36} color="#B3A369" /></div>,
    balance: "0",
    currency:"BTC",
    scanLink: "",
    network:'bitcoin'
  }, 
   { 
    token:"eth",
    name:"Ethereum",
    icon: () => <div className="wallet-card-icon"><EthereumIcon size={36} color="#454135" /></div>,
    balance: "0",
    currency:"ETH",
    scanLink: "",
    network:'ethereum'
  }, 
 { 
    token:"usdt_erc20",
    name:"USDT ERC20",
    icon: () => <div className="wallet-card-icon"><EthereumIcon size={36} color="#B3A369" /></div>,
    balance: "0",
    currency:"USDT",
    scanLink: "",
    network:'ethereum'
  }, 
  { 
    token:"usdc_erc20",
    name:"USDC ERC20",
    icon: () => <div className="wallet-card-icon"><EthereumIcon size={36} color="#b9b9b9" /></div>,
    balance: "0",
    currency: "USDC",
    scanLink: "",
    network:'ethereum'
  }, 
   { 
    token:"bnb",
    name:"Binance",
    icon: () => <div className="wallet-card-icon"><BinanceIcon size={36} color="#F3BA2F" /></div>,
    balance: "0",
    currency: "BNB",
    scanLink: "",
    network:'bnb'
  }, 
   { 
    token:"usdt_bep20",
    name:"USDT BEP20",
    icon: () => <div className="wallet-card-icon"><BinanceIcon size={36} color="#a38231" /></div>,
    balance: "0",
    currency: "USDT",
    scanLink: "",
    network:'bnb'
  }, 
  { 
    token:"trx",
    name:"Tron",
    icon: () => <div className="wallet-card-icon"><TronIcon size={36} color="#FF060A" /></div>,
    balance: "0",
    currency: "TRX",
    scanLink: "",
    network:'tron'
  },
  { 
    token:"usdt_tron",
    name:"USDT TRC20",
    icon: () => <div className="wallet-card-icon"><TronIcon size={36} color="#7d1f28" /></div>,
    balance: "0",
    currency: "USDT",
    scanLink: "",
    network:'tron'
  },
 { 
    token:"sol",
    name:"Solana",
    icon: () => <div className="wallet-card-icon"><SolanaIcon size={36} color="#0651fd" /></div>,
    balance: "0",
    currency: "SOL",
    scanLink: "",
    network:'solana'
  },
  { 
    token:"usdt_spl",
    name:"USDT SPL",
    icon: () => <div className="wallet-card-icon"><SolanaIcon size={36} color="#8a6d8f" /></div>,
    balance: "0",
    currency: "USDT",
    scanLink: "",
    network:'solana'
  },
  { 
    token:"usdc_spl",
    name:"USDC SPL",
    icon: () => <div className="wallet-card-icon"><SolanaIcon size={36} color="#8D70DE" /></div>,
    balance: "0",
    currency: "USDC",
    scanLink: "",
    network:'solana'
  },
];

export const CRYPTO_PRICES: CryptoPrices ={
  BTC: 65000,
  ETH: 4000,
  USDT_ERC20: 1,
  TRX: 0.05, 
  USDT_TRON: 1,
  BNB:600,
  USDT_BEP20: 1, 
}
export const FIATEXCHANGERATE:FiatExchangeRates ={
  USD: 1.0, 
  EUR: 1.08, 
  GBP: 1.27,
  AED: 0.27,
  MEX: 0.05,
  PAN: 1.0
}